import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveValueNameQr } from "../../../redux/slices/saveValue";
import InputText from "../inputText";

const QrTitleField = ({ popoverText, onChange, ...params }) => {
  const { lang, optional } = useSelector((state) => ({
    lang: state.changeLang.language.nameQr,
    optional: state.changeLang.language.stepTwo.optional[0],
  }));

  const dispatch = useDispatch();

  const setQrTitle = (e) => {
    onChange(e);
    dispatch(saveValueNameQr(e.target.value));
  };
  return (
    <InputText
      {...params}
      onChange={setQrTitle}
      placeholder={`${lang[0]} (${optional})`}
      popoverText={popoverText === null ? null : lang[2]}
      maxLength={250}
    />
  );
};

export default QrTitleField;
